module.exports = __webpack_public_path__ + "static/media/eventTracker-logo-blanco.fd1687c6.svg";